exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popover-title[data-v-c7566e4e]{font-size:.8rem;background-color:#fef7ea}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c7566e4e&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popover/AddSchoolCodePopover.vue
// module id = 539
// module chunks = 0